import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';

const FeatureSection = () => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start'],
  });

  const y = useTransform(scrollYProgress, [0, 1], [50, -50]);

  return (
    <section
      ref={sectionRef}
      className="relative h-[60vh] md:h-[70vh] flex items-center justify-center overflow-hidden"
      data-testid="feature-section"
    >
      {/* Background Image with Parallax */}
      <motion.div
        style={{ y }}
        className="absolute inset-0 z-0"
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#2D3436]/80 via-[#3D352D]/60 to-[#2C6E63]/40 z-10" />
        <motion.img
          initial={{ scale: 1.15 }}
          whileInView={{ scale: 1.0 }}
          transition={{ duration: 2.5, ease: "easeOut" }}
          viewport={{ once: true }}
          src="/projects/2024 BAR COUNTER 01.jpeg"
          alt="Premium bar counter installation"
          className="w-full h-full object-cover"
        />
      </motion.div>

      {/* Content */}
      <div className="relative z-20 px-6 md:px-12 lg:px-24 max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <p className="text-[#D4C4A8] text-sm uppercase tracking-[0.3em] mb-6">
            Our Philosophy
          </p>
          <h2
            className="font-heading text-4xl sm:text-5xl md:text-6xl font-light tracking-tight leading-[1.15] text-white mb-8"
            data-testid="feature-heading"
          >
            Creating High-Performance Kitchen Environments
          </h2>
          <p
            className="text-lg sm:text-xl font-light leading-relaxed text-white/80 max-w-2xl mx-auto"
            data-testid="feature-description"
          >
            We blend technical expertise, craftsmanship, and seamless execution to deliver kitchen systems that maximize efficiency and elevate operations.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FeatureSection;
